import React from 'react'
import ReactDOM from 'react-dom'
import { useSpring, animated } from 'react-spring'
import Cards3 from "./Cards_3";
//import Cards5 from "./Cards_5";
//import Cards7 from "./Cards_7";
import { NavLink, Link } from "react-router-dom";

const calc = (x, y) => [-(y - window.innerHeight / 2) / 20, (x - window.innerWidth / 2) / 20, 1.1]
const trans = (x, y, s) => `perspective(600px) rotateX(${x}deg) rotateY(${y}deg) scale(${s})`








function handleSolution () {
  //event.preventDefault();
try {
  this.props.history.push("/solution#risk_solution"); 
}catch(error) {
  console.log(error.message);
}
};

function Card() {
  const [props, set] = useSpring(() => ({ xys: [0, 0, 1], config: { mass: 5, tension: 350, friction: 40 } }))


  var divStyle = {
    color: 'blue',
    cursor: 'pointer',
  }
/*
       <div className="">
            <animated.div
                    class="card1"
                    onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
                    onMouseLeave={() => set({ xys: [0, 0, 1] })}
                    style={{ transform: props.xys.interpolate(trans) , width : "19%" , backgroundImage:  'url("./pictures/images_7.jpg")' }}    
                   
            /> 


    

        </div>
*/


  return (
    <div className="">

 

       

        <div   id = "signal-report"    className="card-1"    style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}    >
        <br></br>
          <a     id ="Strategy" aria-expanded="false"   className= "" ><img  className=""  width="170px" height="70px" src="./pictures/images_29.png"></img><span className="doc-content-title">Cloud-Based Trading Intelligence Platform</span></a>
                            <div className="wrapper_line"></div>

                            <br></br>

                  <p id="page_summary_id" className="page_summary_id">
                  <span>Our platform is a Regime-Aware Automated Trading Environment powered by advanced machine learning and deep learning architectures that serve as the primary intelligence layer in the investment decision-making process.</span>
                  <span>The system transforms isolated technical indicators, fragmented multi-timeframe analysis, and conventional copy-trading into a unified, visualized, and risk-governed trading ecosystem.</span>
                  <span>Rather than relying on blind signal replication, our infrastructure contextualizes market behavior through structured regime detection, indicator-state modeling, and real-time execution intelligence through a built-in API connectivity with MetaTrader 5, Ndax and Interactive Brokers (IBKR).</span>

                   <br></br>    

                  
                  <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                  >
                    Learn more ...
                  </NavLink>
                
                  <br></br>  

                  </p>

                  <br></br>
                  <Cards3 />
                  <br></br>


        </div>

       

</div>

  )
};

export default Card; 


